import React, { FC, ReactNode, CSSProperties } from 'react';
import { useTheme } from '../../../hooks/useTheme';
import styles from './Header.module.css';
import clsx from 'clsx';

export interface HeaderProps {
  containerCustomStyle?: CSSProperties;
  // componentThemeOverrides from broadcastBanner
  headerCustomStyle?: CSSProperties;
  children?: ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
  headerTextRole?: string;
  className?: string;
}

export type HeaderComponent = FC<HeaderProps>;

const HugeHeader: HeaderComponent = ({
  containerCustomStyle,
  children,
  as = 'h1',
  headerTextRole,
  className = '',
}: HeaderProps): ReturnType<HeaderComponent> => {
  const { headersHugeNone: hugeHeaderStyle } = useTheme();
  const Element = as;
  const classes = clsx({
    [styles.hugeHeader]: true,
    [className]: true,
  });

  return (
    <Element
      className={classes}
      style={{
        ...containerCustomStyle,
        ...hugeHeaderStyle,
      }}
      role={headerTextRole}
    >
      {children}
    </Element>
  );
};

const BigHeader: HeaderComponent = ({
  containerCustomStyle,
  children,
  as = 'h2',
  headerTextRole,
  className = '',
}: HeaderProps): ReturnType<HeaderComponent> => {
  const { headersBigNone: bigHeaderStyle } = useTheme();
  const Element = as;
  const classes = clsx({
    [styles.bigHeader]: true,
    [className]: true,
  });

  return (
    <Element
      className={classes}
      style={{
        ...containerCustomStyle,
        ...bigHeaderStyle,
      }}
      role={headerTextRole}
    >
      {children}
    </Element>
  );
};

const SemibigHeader: HeaderComponent = ({
  containerCustomStyle,
  children,
  as = 'h3',
  headerTextRole,
  className = '',
}: HeaderProps): ReturnType<HeaderComponent> => {
  const { headersSemibigNone: semibigHeaderStyle } = useTheme();
  const Element = as;
  const classes = clsx({
    [styles.semiBigHeader]: true,
    [className]: true,
  });

  return (
    <Element
      className={classes}
      style={{
        ...containerCustomStyle,
        ...semibigHeaderStyle,
      }}
      role={headerTextRole}
    >
      {children}
    </Element>
  );
};

const MediumHeader: HeaderComponent = ({
  containerCustomStyle,
  headerCustomStyle,
  children,
  as = 'h4',
  headerTextRole,
  className = '',
}: HeaderProps): ReturnType<HeaderComponent> => {
  const { headersMediumNone: mediumHeaderStyle } = useTheme();
  const Element = as;
  const classes = clsx({
    [styles.mediumHeader]: true,
    [className]: true,
  });

  return (
    <Element
      className={classes}
      style={{
        ...containerCustomStyle,
        ...(headerCustomStyle ?? mediumHeaderStyle),
      }}
      role={headerTextRole}
    >
      {children}
    </Element>
  );
};

const SmallHeader: HeaderComponent = ({
  containerCustomStyle,
  children,
  as = 'h5',
  headerTextRole,
  className = '',
}: HeaderProps): ReturnType<HeaderComponent> => {
  const { headersSmallNone: smallHeaderStyle } = useTheme();
  const Element = as;
  const classes = clsx({
    [styles.smallHeader]: true,
    [className]: true,
  });

  return (
    <Element
      className={classes}
      style={{
        ...containerCustomStyle,
        ...smallHeaderStyle,
      }}
      role={headerTextRole}
    >
      {children}
    </Element>
  );
};

export { HugeHeader };

export { BigHeader };

export { SemibigHeader };

export { MediumHeader };

export { SmallHeader };
